import { fbDB } from "../config/firebase";
import { USERS_PUBLIC_WATCH_ON, USERS_PUBLIC_UPDATE } from "./types";

export const usersPublicWatchOn = () => async dispatch => {
  fbDB.ref(`/usersPublic`).on("value", snapshot => {
    // console.log(snapshot.val());
    return dispatch({
      type: USERS_PUBLIC_WATCH_ON,
      payload: snapshot.val()
    });
  });
};

export const usersPublicWatchOff = () => async dispatch => {
  fbDB.ref(`/usersPublic`).off();
};

export const usersPublicUpdate = data => async dispatch => {
  fbDB
    .ref(`/usersPublic`)
    .set(data)
    .then(() => {
      console.log("usersPublicUpdate Success");
    })
    .catch(err => console.log(err));
};
